import React, { useEffect, useRef, useState } from "react";
import { Briefcase, Search } from "react-feather";
import LoadingSpinner from "../../components/LoadingSpinner";
import Dropdown from "../../components/input/Dropdown";
import useUserCompany from "../../hooks/useUserCompany";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Input from "../../components/input/Input";
import { statusByContext } from "../../api/statusApi";
import { FORMS, MODULES, STATUS_GROUPS } from "../../const";
import { useSelector } from "react-redux";
import SearchDropdown from "../../components/input/SearchDropdown";
import Button from "../../components/input/Button";
import Grid from "../../components/Grid";
import { userBasedJobSearch } from "../../api/jobApi";
import {
  DateOnlyCellRenderer,
  DateTimeCellRenderer,
  ResizableScrollingTextRenderer,
} from "../../components/renderer/StyleRenderer";
import Modal from "../../components/Modal";
import JobChange from "../../components/support/job modification/JobChange";
import { ACTIONS } from "./jobChangeMenu";
import { getJobModificationDetails } from "../../api/jobModificationApi";
import { Action } from "history";

const JobModification = () => {
  const [tab, setTab] = useState(1);
  const [accordion, setAccordion] = useState(true);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [dateTypeOptions, setDateTypeOptions] = useState([]);
  const [resetVisible, setResetVisible] = useState(false);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [dateType, setDateType] = useState(5);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [vehicleType, setVehicleType] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [onTime, setOnTime] = useState(null);
  const [transporter, setTransporter] = useState([]);
  const [shipper, setShipper] = useState([]);
  const [jobStatus, setJobStatus] = useState([]);
  const [jobNos, setJobNos] = useState("");
  const [reqNos, setReqNos] = useState("");
  const [vehNos, setVehNos] = useState("");
  const [shipmentCreator, setShipmentCreator] = useState(null);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [reloadDates, setReloadDates] = useState(true);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [jobDetails, setJobDetails] = useState(null);
  const [chargeableKmStatuses, setChargeableKmStatuses] = useState([]);
  const [isLoadingJobDetails, setIsLoadingJobDetails] = useState(false);

  const userCompany = useUserCompany();
  const gridRef = useRef(null);
  const modalRef = useRef(null);

  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.user.permissions[MODULES.Support]);

  const company = useUserCompany();
  const billingCustomerPermission =
    auth[FORMS.JOB_MODIFICATION.BILLING_CUSTOMER.form]?.FIELD?.VIEW;
  const invoicingCustomerPermission =
    auth[FORMS.JOB_MODIFICATION.INVOICING_CUSTOMER.form]?.FIELD?.VIEW;
  const creatorRemarkPermission =
    auth[FORMS.JOB_MODIFICATION.CREATOR_REMARK.form]?.FIELD?.VIEW;
  const operationRemarkPermission =
    auth[FORMS.JOB_MODIFICATION.OPERATION_REMARK.form]?.FIELD?.VIEW;
  const plantPermission = auth[FORMS.JOB_MODIFICATION.PLANT.form]?.FIELD?.VIEW;
  const vehiclePermission =
    auth[FORMS.JOB_MODIFICATION.VEHICLE.form]?.FIELD?.VIEW;
  const requestArrivalPermission =
    auth[FORMS.JOB_MODIFICATION.REQUEST_ARRIVAL.form]?.FIELD?.VIEW;
  const deliveryCutoffPermission =
    auth[FORMS.JOB_MODIFICATION.DELIVERY_CUTOFF.form]?.FIELD?.VIEW;
  const otherRequestPermission =
    auth[FORMS.JOB_MODIFICATION.REQUEST_OTHER.form]?.FIELD?.VIEW;
  const chargeableKmPermission =
    auth[FORMS.JOB_MODIFICATION.CHARGEABLE_KM.form]?.FIELD?.VIEW;

  useEffect(() => {
    (async () => {
      const { date_types: dateTypeData } = await getBulkDropdownData([
        { key: "date_types" },
      ]);
      setDateTypeOptions(dateTypeData);

      const jobStatusData = await statusByContext(
        userData.type === 2
          ? STATUS_GROUPS.CUSTOMER_STATUS
          : userData.type === 3
            ? STATUS_GROUPS.TRANSPORTER_STATUS
            : STATUS_GROUPS.INTERNAL_STATUS,
      );
      console.log("job status data", jobStatusData);
      setJobStatusOptions(jobStatusData);

      const chargeableKmStatusData = await statusByContext(
        STATUS_GROUPS.CHARGEABLE_KM_UPDATE,
      );
      setChargeableKmStatuses(chargeableKmStatusData || []);
      console.log("chargeable km status", chargeableKmStatusData);
    })();
  }, []);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const jobModificationSearchRequest = {
    lDataType: dateType,
    dFromData: fromDate,
    dToDate: toDate,
    sCustomer: customer.length > 0 ? customer.join(",") : null,
    sShipper: shipper.length > 0 ? shipper.join(",") : null,
    sJobStatus: jobStatus && jobStatus.length > 0 ? jobStatus.join(",") : null,
    sJobNos: jobNos,
    sRequestNos: reqNos,
    sVehicleNos: vehNos ? vehNos.toUpperCase() : "",
    sFlaggedType: null,
    sResolved: null,
    sStatus: 2,
    sActive: 1,
    customerGroup: null,
    sTransporters: transporter.length > 0 ? transporter.join(",") : null,
    lCompany: userCompany.comId,
    vehicleType: vehicleType.length > 0 ? vehicleType.join(",") : null,
    jobOnTime: onTime,
    shipmentCreator: null,
  };
  const handleSearch = async (e) => {
    e.preventDefault();
    setResetVisible(true);
    setSearchClicked(true);
    setSearchSubmitLoading(true);
    const response = await userBasedJobSearch(jobModificationSearchRequest);
    setSearchResults(response);

    setSearchSubmitLoading(false);
  };
  const getActionMenuOptions = () => {
    const selectedData = gridRef.current?.getSelectedData() || [];
    const isMultiple = selectedData.length > 1;

    const allOptions = [
      {
        key: ACTIONS.BILLING_CUSTOMER,
        text: "Billing Customer",
        value: ACTIONS.BILLING_CUSTOMER,
        permission: billingCustomerPermission,
      },
      {
        key: ACTIONS.INVOICING_CUSTOMER,
        text: "Invoicing Customer",
        value: ACTIONS.INVOICING_CUSTOMER,
        permission: invoicingCustomerPermission,
      },
      {
        key: ACTIONS.CREATOR_REMARK,
        text: "Creator Remark",
        value: ACTIONS.CREATOR_REMARK,
        permission: creatorRemarkPermission,
      },
      {
        key: ACTIONS.OPERATION_REMARK,
        text: "Operation Remark",
        value: ACTIONS.OPERATION_REMARK,
        permission: operationRemarkPermission,
      },
      {
        key: ACTIONS.PLANT_CHANGE,
        text: "Plant",
        value: ACTIONS.PLANT_CHANGE,
        permission: plantPermission,
      },
      {
        key: ACTIONS.OTHER_REQUEST,
        text: "Other Request",
        value: ACTIONS.OTHER_REQUEST,
        permission: otherRequestPermission,
      },
      {
        key: ACTIONS.VEHICLE_CHANGES,
        text: "Vehicle Changes",
        value: ACTIONS.VEHICLE_CHANGES,
        permission: vehiclePermission,
      },
      {
        key: ACTIONS.REQUEST_ARRIVAL_TIME,
        text: "Request Arrival Time",
        value: ACTIONS.REQUEST_ARRIVAL_TIME,
        permission: requestArrivalPermission,
      },
      {
        key: ACTIONS.DELIVERY_CUTOFF_DATE,
        text: "Delivery Cutoff Date",
        value: ACTIONS.DELIVERY_CUTOFF_DATE,
        permission: deliveryCutoffPermission,
      },
      {
        key: ACTIONS.KM_CHANGE,
        text: "Km Change",
        value: ACTIONS.KM_CHANGE,
        permission: chargeableKmPermission,
      },
    ];
    const bulkAllowed = [
      ACTIONS.BILLING_CUSTOMER,
      ACTIONS.INVOICING_CUSTOMER,
      ACTIONS.CREATOR_REMARK,
      ACTIONS.OPERATION_REMARK,
      ACTIONS.PLANT_CHANGE,
      ACTIONS.KM_CHANGE,
    ];

    return allOptions.filter((option) => {
      if (!option.permission) return false;

      if (isMultiple) {
        const isAnyRestricted = selectedData.some((row) =>
          chargeableKmStatuses.some(
            (status) => String(status.value) === String(row?.staId),
          ),
        );

        if (isAnyRestricted && option.value === ACTIONS.KM_CHANGE) {
          return false;
        }
        return bulkAllowed.includes(option.value);
      }

      if (selectedData.length === 1) {
        const currentJobStatus = selectedData[0]?.staId;
        const isRestrictedStatus = chargeableKmStatuses.some(
          (status) => String(status.value) === String(currentJobStatus),
        );

        if (isRestrictedStatus && option.value === ACTIONS.KM_CHANGE) {
          return false;
        }
      }
      return true;
    });
  };

  const handleJobModification = (action) => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRow(selectedData);
    console.log("selected job details", selectedData);

    setSelectedAction(action);
  };

  const actionsMenuChange = async (data) => {
    handleJobModification(data.value);
    setSelectedAction(data.value);

    const selectedData = gridRef.current.getSelectedData();
    if (!selectedData || selectedData.length === 0) return;
    try {
      setIsLoadingJobDetails(true);
      if (selectedData.length > 1) {
        const multiPayload = selectedData.map((row) => ({
          jobId: row.jobId,
          requestId: row.reqId,
        }));
        setJobDetails(multiPayload);
      } else {
        const selectedJob = selectedData[0];

        const details = await getJobModificationDetails(selectedJob.jobId);
        setJobDetails({
          jobId: selectedJob.jobId,
          requestId: details.reqId,
          billingCustomerId: details.billingCustomer || null,
          invoicingCustomerId: details.invoicingCustomer || null,
          creatorRemark: details.creatorRemark || "",
          operationRemark: details.operationRemark || "",
          plant: details.plant || null,
          transporter: details.transporter || null,
          vehicle: details.vehicle || null,
          driver: details.driver || null,
          helper: details.helper || null,
          vehicleType: details.vehicleType || null,
          arrivalTime: details.arrivalEta || null,
          deliveryCutoffDate: details.deliveryCutoff || null,
          customer: details.customer,
          chargeableKm: details.chargeableKm,
          kmActual: details.kmActual,
        });
      }
      setIsLoadingJobDetails(false);
      setIsModalOpen(true);
      modalRef.current?.showModal();
    } catch (error) {
      console.error("Error fetching job details:", error);
      setIsLoadingJobDetails(false);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setJobDetails(null);
    setSelectedAction(null);
    setIsLoadingJobDetails(false);

    if (gridRef.current) {
      const selectedNodes = gridRef.current.getSelectedNodes();
      selectedNodes.forEach((node) => {
        node.setSelected(false);
      });
    }
    setSelectedRow([]);

    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setDateType(5);
    setJobNos("");
    setReqNos("");
    setVehNos("");
    setCustomer([]);
    setJobStatus([]);
    setShipper([]);
    setTransporter([]);
    setVehicleType([]);
    setShipmentCreator(null);
    setReloadDates(true);
  };

  return (
    <div>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu top attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Briefcase size={15} style={{ marginRight: "5px" }} />
            </span>
            Job Search
          </div>
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${accordion ? "active" : ""}`}
            onClick={() => {
              setAccordion(!accordion);
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div className={`content ${accordion ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="four fields">
                  <Dropdown
                    required={true}
                    options={dateTypeOptions}
                    label="Date Type"
                    style={{ height: "20px" }}
                    value={dateType}
                    onChange={(e, data) => {
                      setDateType(data.value);
                    }}
                    clearable={false}
                  />
                  <Input
                    required={true}
                    type="date"
                    label="From Date"
                    name="fromDate"
                    max={toDate ?? null}
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                  />
                  <Input
                    required={true}
                    label="To Date"
                    type="date"
                    name="toDate"
                    min={fromDate}
                    value={toDate}
                    disabled={!fromDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                  />
                  <Dropdown
                    clearable
                    search={true}
                    options={jobStatusOptions}
                    placeholder="Job Status"
                    label="Job Status"
                    value={jobStatus}
                    onChange={(e, data) => {
                      setJobStatus(data.value);
                    }}
                    multiple={true}
                  />
                </div>
                <div className="four fields">
                  <Input
                    label="Job Numbers"
                    type="text"
                    placeholder="Ex:JOB-0000123"
                    name="jobnos"
                    value={jobNos}
                    onChange={(e) => {
                      setJobNos(e.target.value);
                    }}
                  />
                  <Input
                    label="Request Numbers"
                    type="text"
                    placeholder="Ex:REQ-00000123"
                    name="reqnos"
                    value={reqNos}
                    onChange={(e) => {
                      setReqNos(e.target.value);
                    }}
                  />
                  <Input
                    label="Vehicle Numbers"
                    type="text"
                    placeholder="Ex:LG-0123"
                    name="vehnos"
                    value={vehNos}
                    onChange={(e) => {
                      setVehNos(e.target.value);
                    }}
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple={true}
                    multiValueRemoveHandler={(key) => {
                      setCustomer((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                      );
                    }}
                    onResultSelect={(data) =>
                      setCustomer((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "user_stakeholder",
                      value: "Requesting Customer",
                      param2: user.username,
                    }}
                    label="Request Customer"
                  />
                </div>
                <div className="four fields">
                  <SearchDropdown
                    key={2}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple={true}
                    multiValueRemoveHandler={(key) => {
                      setShipper((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                      );
                    }}
                    onResultSelect={(data) =>
                      setShipper((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={
                      userData.type === 1
                        ? {
                            type: "stakeholder_type",
                            value: "Shipper",
                            param2:
                              customer.length > 0 ? customer.join(",") : "",
                          }
                        : {
                            type: "user_stakeholder",
                            value: "Shipper",
                            param1:
                              customer.length > 0 ? customer.join(",") : "",
                            param2: user.username,
                          }
                    }
                    label="Shipper/Plant"
                  />
                  <SearchDropdown
                    key={2}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple={true}
                    multiValueRemoveHandler={(key) => {
                      setTransporter((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                      );
                    }}
                    onResultSelect={(data) =>
                      setTransporter((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={
                      userData.type === 3
                        ? {
                            type: "user_stakeholder",
                            value: "Transporter",
                            param2: user.username,
                          }
                        : {
                            type: "stakeholder_type",
                            value: "Transporter",
                          }
                    }
                    label="Transporter"
                  />
                  <SearchDropdown
                    key={
                      resetSearchFields
                        ? `vehicle_type_reset_${Date.now()}`
                        : "vehicle_type"
                    }
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple={true}
                    multiValueRemoveHandler={(key) => {
                      setVehicleType((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                      );
                    }}
                    onResultSelect={(data) =>
                      setVehicleType((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "vehicle_type",
                      value: "",
                    }}
                    label="Vehicle Type"
                  />
                  <SearchDropdown
                    value={shipmentCreator}
                    label={"Shipment Creator"}
                    name={"shipment_creator"}
                    clearable={true}
                    onClear={() => setShipmentCreator(null)}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    onResultSelect={(data) => setShipmentCreator(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "user",
                      value: userData.type.toString(),
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={handleSearch} />
                    <Button template="searchReset" onClick={onReset} />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <div>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                ref={gridRef}
                heading="Jobs"
                multiRowSelection={true}
                onSelectionChanged={handleJobModification}
                handleActionMenuChange={actionsMenuChange}
                showActionMenu={selectedRow.length > 0}
                actionMenuOptions={getActionMenuOptions()}
                content={searchResults}
                config={[
                  {
                    headerName: "Job code",
                    field: "jobCode",
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                  },
                  {
                    headerName: "Request",
                    field: "reqCode",
                  },
                  {
                    headerName: "Job Status",
                    field: "gridStatusName",
                  },
                  {
                    headerName: "Customer",
                    field: "customerName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Invoicing Customer",
                    field: "invoicingCustomer",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Billing Customer",
                    field: "billingCustomer",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Creator Remark",
                    field: "creatorRemark",
                  },
                  {
                    headerName: "Operation Remark",
                    field: "jobOperationRemark",
                  },
                  {
                    headerName: "Plant",
                    field: "plantName",
                  },
                  {
                    headerName: "Other Request",
                    field: "otherCharges",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Request Arrival Time",
                    field: "arrivalEta",
                    cellRenderer: DateTimeCellRenderer,
                  },
                  {
                    headerName: "Vehicle Type",
                    field: "vhtType",
                  },
                  {
                    headerName: "Transporter",
                    field: "stkName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },

                  {
                    headerName: "Driver",
                    field: "driverName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Helper",
                    field: "helperName",
                  },
                  {
                    headerName: "Delivery Cutoff Date",
                    field: "reqDeliveryCutOffTime",
                    cellRenderer: DateTimeCellRenderer,
                  },
                ]}
              />
            )}
          </div>
        )}
      </div>
      <Modal
        ref={modalRef}
        minWidth={"60vw"}
        minHeight={"50vh"}
        //style={{ height: "50vh" }}
        open={isModalOpen}
        onClose={handleModalClose}
        onCloseCleanUp={handleModalClose}
      >
        <JobChange
          closeModal={handleModalClose}
          actionType={selectedAction}
          editMode={true}
          initialData={jobDetails}
          isOpen={isModalOpen}
        />
      </Modal>
    </div>
  );
};

export default JobModification;
